import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, ApplicationNavigationEventType } from '../constants';

export class NavigationApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Navigation;

  constructor(
    private navigationType: ApplicationNavigationEventType,
    private title?: string,
    private path?: string,
    private additionalData?: any
  ) {}

  getPayload(): any {
    return {
      type: this.navigationType,
      title: this.title,
      path: this.path,
      additionalData: this.additionalData
    };
  }
}
